import NestedForm from "stimulus-rails-nested-form";

export default class extends NestedForm {

  static targets = ["header"];

  static values = {
    minItems: { type: Number, default: 1 },
    maxItems: { type: Number, default: Infinity },
  };

  connect() {
    super.connect();
    this.updateHeaders();
    this.updateButtons();
  }

  add(event) {
    event.preventDefault();
    if (this.itemCount() < this.maxItemsValue) {
      // Add new items to the second target (for proper ordering)
      const content = this.templateTarget.innerHTML.replace(
        /NEW_RECORD/g,
        new Date().getTime(),
      );
      const targets = this.element.querySelectorAll(
        '[data-external-controls-nested-form-target="target"]',
      );
      const newItemsTarget = targets[targets.length - 1]; // Get the last target
      newItemsTarget.insertAdjacentHTML("beforeend", content);
      this.updateHeaders();
      this.updateButtons();
    }
  }

  remove(event) {
    event.preventDefault();
    if (this.itemCount() > this.minItemsValue) {
      // Find the last visible item and mark it for destruction
      const visibleWrappers = Array.from(
        this.element.querySelectorAll(".nested-form-wrapper"),
      ).filter((wrapper) => {
        const destroyField = wrapper.querySelector('input[name*="[_destroy]"]');
        return (
          !(destroyField?.value === "1") && wrapper.style.display !== "none"
        );
      });

      if (visibleWrappers.length > 0) {
        const lastWrapper = visibleWrappers[visibleWrappers.length - 1];

        // For new records, just remove from DOM
        if (lastWrapper.dataset.newRecord === "true") {
          lastWrapper.remove();
        } else {
          // For existing records, mark for destruction
          const destroyField = lastWrapper.querySelector(
            'input[name*="[_destroy]"]',
          );
          if (destroyField) {
            destroyField.value = "1";
            lastWrapper.style.display = "none";
          }
        }
      }
      this.updateHeaders();
      this.updateButtons();
    }
  }

  updateHeaders() {
    const visibleWrappers = Array.from(
      this.element.querySelectorAll(".nested-form-wrapper"),
    ).filter((wrapper) => {
      const destroyField = wrapper.querySelector('input[name*="[_destroy]"]');
      return (
        !(destroyField?.value === "1") && wrapper.style.display !== "none"
      );
    });

    visibleWrappers.forEach((wrapper, index) => {
      const header = wrapper.querySelector('[data-external-controls-nested-form-target="header"]');
      const intro = wrapper.querySelector('.nested-form-intro');

      if (header) {
        header.textContent = index === 0 ? "Activiteit" : `Activiteit ${index + 1}`;
      }

      // Show intro text only on first form
      if (intro) {
        intro.style.display = index === 0 ? '' : 'none';
      }
    });
  }

  itemCount() {
    const wrappers = this.element.querySelectorAll(".nested-form-wrapper");
    return Array.from(wrappers).filter((wrapper) => {
      const destroyField = wrapper.querySelector('input[name*="[_destroy]"]');
      const isDestroyed = destroyField && destroyField.value === "1";
      const isHidden = wrapper.style.display === "none";
      return !isDestroyed && !isHidden;
    }).length;
  }

  updateButtons() {
    const count = this.itemCount();
    console.log("Item count:", count, "Max items:", this.maxItemsValue);

    const addBtn = this.element.querySelector(
      '[data-action="external-controls-nested-form#add"]',
    );
    const removeBtn = this.element.querySelector(
      '[data-action="external-controls-nested-form#remove"]',
    );

    if (addBtn) {
      if (count >= this.maxItemsValue) {
        addBtn.style.setProperty("display", "none", "important");
      } else {
        addBtn.style.removeProperty("display");
      }
    }

    if (removeBtn) {
      if (count <= this.minItemsValue) {
        removeBtn.style.setProperty("display", "none", "important");
      } else {
        removeBtn.style.removeProperty("display");
      }
    }
  }
}
